module.exports = __webpack_public_path__ + "static/media/filter-icon.64442e41.svg";